<div class="tables-container">
  <div class="options-container">
    <div class="filter-container">
      <app-filter
        [uniqueServices]="uniqueServices"
        [selectedServices]="selectedServices"
        [selectedStatuses]="selectedStatuses"
        (filterChanged)="filterData()"
        (searchTextChanged)="onSearchTextChanged($event)"
        (selectedServicesChanged)="onSelectedServicesChanged($event)"
        (selectedStatusesChanged)="onSelectedStatusesChanged($event)"
      ></app-filter>
    </div>
    <div class="paginator-container">
      <mat-paginator
        [pageSizeOptions]="[15, 30, 60]"
        showFirstLastButtons
        *ngIf="!isFiltering"
      >
      </mat-paginator>
    </div>
  </div>
  <div class="team-status-container">
    <div *ngFor="let account of accountData" class="team-status-table">
      <div class="team-header">
        <h3>{{ account.TeamName || account.AccountID }}</h3>
        <p>アカウントID: {{ account.AccountID }}</p>
        <div class="status-info-container">
          <div class="total-score-container">
            <p>総合点: {{ account.TotalScore }}点</p>
            <span>{{ getRankByTotalScore(account.TotalScore) }}位</span>
          </div>
          <div class="completion-container">
            <p>：{{ getCompletionPercentage(account.AccountID) }}% 完了</p>
            <span>({{ getCompletedControlCount(account.AccountID) }}/{{ getTotalControlCount(account.AccountID) }})</span>
          </div>
        </div>
      </div>

      <div class="latest-application-container">
        <h3>最新の申請</h3>
        <div
          *ngIf="
            latestApplications[account.AccountID];
            else nolatestApplications
          "
        >
          {{ latestApplications[account.AccountID].ControlID }}
          <p>
            {{
              latestApplications[account.AccountID].ApplicationTimestamp
                | timeAgo
                | async
            }}
          </p>
        </div>
        <ng-template #nolatestApplications>
          <div>
            -
            <p>-</p>
          </div>
        </ng-template>
      </div>

      <mat-table [dataSource]="filteredDataSource[account.AccountID]" class="mat-table-container">
        <ng-container matColumnDef="ControlID">
          <mat-header-cell
            *matHeaderCellDef
            class="control-id-cell"
          >
            コントロールID
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="control-id-cell">
            {{ element.ControlID }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef class="status-cell">
            ステータス
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="status-cell">
            <span class="status status-{{ element.Status }}">
              {{ ControlStatusJP[element.Status] }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ApplicationCount">
          <mat-header-cell *matHeaderCellDef class="application-count-cell">
            申請回数
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="application-count-cell">
            <span
              *ngIf="element.ApplicationCount >= 1"
              class="application-count"
              [ngClass]="{
                'application-count-3': element.ApplicationCount >= 3,
                'application-count-5': element.ApplicationCount >= 5
              }"
              >{{ element.ApplicationCount }}回</span
            >
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="['ControlID', 'Status', 'ApplicationCount']"
        ></mat-header-row>
        <mat-row
          *matRowDef="
            let row;
            columns: ['ControlID', 'Status', 'ApplicationCount']
          "
          [ngClass]="{ 'gray-out': row.Status === 4 }"
        ></mat-row>
      </mat-table>
    </div>
  </div>
</div>
<div class="admin-controls-button">
  <button mat-raised-button color="primary" (click)="openAdminControlsDialog()">
    <mat-icon>settings</mat-icon>
  </button>
</div>
<ng-template #adminControlsDialog> </ng-template>
